import dayjs from 'dayjs';

import { useTimeZonesQuery } from './queries/scheduled-rebalancing/useTimeZonesQuery';

export const useUserTimeZone = () => {
  const { timeZones } = useTimeZonesQuery();

  if (!timeZones) {
    return;
  }

  const parts = dayjs.tz.guess().split('/');
  const userCity = parts[parts.length - 1];

  return timeZones.find((tz) => tz.name?.endsWith(userCity));
};
